import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

const GET_ADDRESS_DETAILS = gql`
  query GetAddressDetails($placeId: String!, $visitorId: String!) {
    getAddressDetails(placeId: $placeId, visitorId: $visitorId) {
      postcode
      street
      state
      city
      country
      formattedAddress
      streetNumber
      stateAbbreviation
    }
  }
`;

/**
 * Apollo request
 */
const getAddressDetailsQuery = async ({ variables }) => {
  try {
    const { data } = await query({
      query: GET_ADDRESS_DETAILS,
      variables: {
        placeId: variables.placeId,
        visitorId: variables.visitorId,
      },
    });

    return data.getAddressDetails;
  } catch (error) {
    throw new Error('Failed to query address details', error);
  }
};

export default getAddressDetailsQuery;
